__turbopack_context__.v({
  "apart": "hero-pill-module-scss-module__uV1vsW__apart",
  "building": "hero-pill-module-scss-module__uV1vsW__building",
  "float": "hero-pill-module-scss-module__uV1vsW__float",
  "heroPill": "hero-pill-module-scss-module__uV1vsW__heroPill",
  "hero_pill_with_images": "hero-pill-module-scss-module__uV1vsW__hero_pill_with_images",
  "icon-ai": "hero-pill-module-scss-module__uV1vsW__icon-ai",
  "image": "hero-pill-module-scss-module__uV1vsW__image",
  "keyboard": "hero-pill-module-scss-module__uV1vsW__keyboard",
  "pie-chart": "hero-pill-module-scss-module__uV1vsW__pie-chart",
  "text": "hero-pill-module-scss-module__uV1vsW__text",
});
